import React, { Component } from "react";
import { Col } from "reactstrap";
import { NavLink } from "react-router-dom";

class CustomCard extends Component {
  state = {};
  
  render() {
    const { size, imgPath, linkPath, title, subtitle ,height ,IdSpe, paddingCost,isVisa} = this.props;
    //isVisas to use black overlay instead of white
    return (
      <Col
        sm={size || "3"}
        className="text-center custom"
        style={{ padding: paddingCost}}
      >
        <div
          className="card-content-item text-center customCardRes"
        >
          <div className="overlay"></div>
          <img
            src={imgPath}
            alt="outdoors"
            className="img-fluid"
            id={IdSpe}
            style={{ height }}
          />

          {isVisa && (
            <NavLink to={linkPath}>
              <div className="name">
                <div className="overlayBlack">
                  <span
                    className="font-weight-bold"
                    style={{ color: "white", fontWeight: "600" }}
                  >
                    <h4 style={{ fontWeight: "600" }}> {title}</h4>
                  </span>
                  <div class="price d-none d-sm-block">{subtitle}</div>
                </div>
              </div>
            </NavLink>
          )}

          {!isVisa && (
            <NavLink to={linkPath} className="py-2 px-4 center-title">
              <div className="name">
                <span class="font-weight-bold">{title}</span>
                <div class="price d-none d-sm-block">{subtitle}</div>
              </div>
            </NavLink>
          )}
        </div>
      </Col>
    );
  }
}

export default CustomCard;
